var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 134.6 122",
    style: {
      enableBackground: "new 0 0 134.6 122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F3F1F1;}\n\t.st1{fill:#5CC6C7;}\n\t.st2{fill:#A89C9A;}\n\t.st3{fill:#CDC6C5;}\n\t.st4{fill:#EDCE68;}\n\t.st5{fill:#273C49;}\n\t.st6{fill:#329F2C;}\n\t.st7{fill:#AFACAC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    transform: "translate(0 -24.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    transform: "translate(0 24.047)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    x: 2,
    y: 2,
    className: "st0",
    width: 130.7,
    height: 118
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    x: 2,
    y: 2,
    className: "st1",
    width: 130.7,
    height: 16.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    className: "st2",
    d: "M73.6,107.4H61c-3.5,0-6.3-2.8-6.3-6.3l0,0l0,0c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0h12.6 c3.5,0,6.3,2.8,6.3,6.3l0,0l0,0C80,104.5,77.1,107.4,73.6,107.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    x: 33.6,
    y: 44.1,
    className: "st3",
    width: 67.5,
    height: 42.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    className: "st4",
    d: "M83.4,66.5l8.9,32.8l8.9-8.9l14.9,14.9l6-6l-14.9-14.9l8.9-8.9L83.4,66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    className: "st5",
    d: "M132.7,0H2C0.9,0,0,0.9,0,2v118c0,1.1,0.9,2,2,2h130.7c1.1,0,2-0.9,2-2V2 C134.7,0.9,133.8,0,132.7,0C132.7,0,132.7,0,132.7,0z M4,118V20.8h25.2c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2H4V4h126.7v12.9H26.3 c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h104.4V118L4,118z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    className: "st5",
    d: "M73.6,92.8H61c-4.6,0-8.3,3.7-8.3,8.3c0,4.6,3.7,8.3,8.3,8.3h12.6c4.6,0,8.3-3.7,8.3-8.3 C81.9,96.5,78.2,92.8,73.6,92.8L73.6,92.8z M73.6,105.4H61c-2.4,0-4.4-1.9-4.4-4.4s1.9-4.4,4.4-4.4h12.6c2.4,0,4.4,1.9,4.4,4.4 S76.1,105.4,73.6,105.4L73.6,105.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    className: "st5",
    d: "M115.5,12.4h0.3c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2h-0.3c-1.1,0-2,0.9-2,2 C113.6,11.5,114.5,12.4,115.5,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    className: "st5",
    d: "M124,12.4h0.3c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2H124c-1.1,0-2,0.9-2,2 C122,11.5,122.9,12.4,124,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    className: "st5",
    d: "M106.8,12.4h0.3c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2l0,0h-0.3c-1.1,0-2,0.9-2,2 C104.9,11.5,105.8,12.4,106.8,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    className: "st5",
    d: "M110,84.4l7.5-7.5c0.8-0.8,0.7-2.1-0.1-2.8c-0.2-0.2-0.5-0.4-0.8-0.5L103,69.8V44.1 c0-1.1-0.9-2-2-2H33.6c-1.1,0-2,0.9-2,2v42.2c0,1.1,0.9,2,2,2h53.7l3.2,11.6c0.3,1.1,1.4,1.7,2.5,1.3c0.3-0.1,0.6-0.3,0.8-0.5 l7.5-7.5l13.5,13.5c0.8,0.8,2,0.8,2.8,0l6-6c0.8-0.8,0.8-2,0-2.8c0,0,0,0,0,0L110,84.4z M35.6,84.3V46.1h63.5v22.6l-15.2-4.1 c-1.1-0.3-2.2,0.4-2.4,1.5c-0.1,0.3-0.1,0.7,0,1l4.7,17.3L35.6,84.3L35.6,84.3z M116.2,102.5L102.7,89c-0.8-0.8-2-0.8-2.8,0 l-6.5,6.5l-7.1-26.2l26.2,7.1l-6.5,6.5c-0.8,0.8-0.8,2,0,2.8c0,0,0,0,0,0l13.5,13.5L116.2,102.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "translate(31.083 57.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    className: "st6",
    d: "M15.1,3.9H2c-1.1,0-2-0.9-2-2s0.9-2,2-2h13.1c1.1,0,2,0.9,2,2S16.2,3.9,15.1,3.9L15.1,3.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    transform: "translate(18.474 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    className: "st6",
    d: "M15.1,3.9H2c-1.1,0-2-0.9-2-2s0.9-2,2-2l0,0h13.1c1.1,0,2,0.9,2,2S16.2,3.9,15.1,3.9L15.1,3.9 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    transform: "translate(55.422 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    className: "st7",
    d: "M15.1,3.9H2c-1.1,0-2-0.9-2-2s0.9-2,2-2l0,0h13.1c1.1,0,2,0.9,2,2S16.2,3.9,15.1,3.9L15.1,3.9 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    transform: "translate(36.948 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    className: "st6",
    d: "M15.1,3.9H2c-1.1,0-2-0.9-2-2s0.9-2,2-2h13.1c1.1,0,2,0.9,2,2S16.2,3.9,15.1,3.9L15.1,3.9z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepOne);
export default __webpack_public_path__ + "static/media/step-one.090276513dfa796440c5ce282e9b96a7.svg";
export { ForwardRef as ReactComponent };